import { RequestLoader } from 'components/common/Loader';
import {
	SUBSCRIPTIONS_GET_BY_SUBSCRIBER,
	SYSTEM_ENTITIES_GET_ENTITY,
} from 'apiRoutes';
import { FunctionComponent, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import BackButton from 'components/common/BackButton/BackButton';
import SectionDivider from 'components/common/SectionDivider';
import { Box, Button } from '@montel/montelpro-shared-components-v2';
import SubscriptionTable from 'components/subscription/SubscriptionTable';
import { SystemEntity } from 'domain/systemEntity/interfaces/SystemEntity';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import {
	EditableSystemEntityDetails,
	SystemEntityDetails,
} from './SystemEntityDetails';
import { subscriptionTableColumns } from 'components/subscription/subscriptionTableColumns';

const SystemEntityProfilePage: FunctionComponent = () => {
	const { id } = useParams();

	const [isEditing, setIsEditing] = useState<boolean>(false);

	const {
		data: systemEntity,
		status,
		getData: getSystemEntity,
	} = useGetOnMount<SystemEntity>(`${SYSTEM_ENTITIES_GET_ENTITY}?id=${id}`);

	const { data: subscriptions, status: subscriptionsStatus } = useGetOnMount<
		Subscription[]
	>(`${SUBSCRIPTIONS_GET_BY_SUBSCRIBER}?subscriberId=${id}`);

	const subscriptionColumns = useMemo(
		() => [
			subscriptionTableColumns.application(),
			subscriptionTableColumns.plan(),
			subscriptionTableColumns.status(),
			subscriptionTableColumns.startDate(),
			subscriptionTableColumns.endDate(),
			subscriptionTableColumns.seats(),
			subscriptionTableColumns.type(),
			subscriptionTableColumns.expandedIndicator(),
		],
		[subscriptions],
	);

	const navigate = useNavigate();

	return (
		<RequestLoader h="500px" status={status}>
			<Box bg="bgMainContainer">
				<BackButton />
				{systemEntity && (
					<Box bg="bgMainContainer">
						{isEditing ? (
							<EditableSystemEntityDetails
								systemEntity={systemEntity}
								setIsEditing={setIsEditing}
								onSuccessfulSubmit={async () => {
									await getSystemEntity();
								}}
							/>
						) : (
							<SystemEntityDetails
								systemEntity={systemEntity}
								setIsEditing={setIsEditing}
							/>
						)}
						<SectionDivider />
						<SubscriptionTable
							columns={subscriptionColumns}
							requestStatus={subscriptionsStatus}
							subscriptions={subscriptions}
						/>
						<Button
							text="Add subscription"
							onClick={() =>
								navigate(
									`/subscriptions/create?systemEntityId=${
										systemEntity.id
									}&companyId=${
										systemEntity.companyId || null
									}`,
								)
							}
						/>
						<SectionDivider />
					</Box>
				)}
			</Box>
		</RequestLoader>
	);
};

export default SystemEntityProfilePage;
